import Button from '@Components/Buttons/Button'
import React from 'react'
import { observer } from 'mobx-react'
import CatalogSearchStore from '@App/stores/search/work/catalog-search-store'

interface ExportButtonProps {
    catalogSearchStore: CatalogSearchStore
    loading: boolean
    setSidebarIsOpen(b: boolean): void
}

// TODO - This button had a view_works check, but presumably that's already been checked by the point they get here - we should reinvestigate when we add songwriter permissions
const CatalogExportButton = (props: ExportButtonProps) => {
    const { catalogSearchStore, loading, setSidebarIsOpen } = props
    return (
        <Button
            submitType="button"
            mainColor
            type="secondary"
            className="export-search-button"
            disabled={!catalogSearchStore.isSearchExportable || loading}
            onClick={() => setSidebarIsOpen(true)}
        >
            Export
        </Button>
    )
}

export default observer(CatalogExportButton)
